export const isExcludedFromMenuBar = (path: string): boolean => {
  if (
    path === "/login" ||
    path === "/logout" ||
    path.startsWith("/password-reset") ||
    path === "/forgot-password" ||
    path === "/request-access"
  )
    return true;
  return false;
};
